export default __webpack_public_path__ + "static/People_Driven_Development-8e0cc62f64273922163a5f5f4ef84eed.png";